import { useCallback } from "react";
import { useSignUpload } from "app/hooks";
import { SetState } from "../types";
import KEYS from "../constants";

interface Props {
  progress: number;
  setState: SetState;
}

const useUploadVideo = ({ progress, setState }: Props) => {
  const signUpload = useSignUpload();

  return useCallback(
    async (selectedMedia, mediaToUpload) => {
      if (process.env.NODE_ENV === "development") return KEYS.DEVELOPMENT_VIDEO_URL;

      return signUpload(selectedMedia, (mediaProgress: number) => {
        const progressRatio = progress === 1 ? 0.75 : 0.9;
        setState({ progress: (mediaProgress / mediaToUpload) * progressRatio });
      });
    },
    [progress, setState, signUpload]
  );
};

export default useUploadVideo;
